import React from "react";
import Skeleton from "./Skeleton";
import styles from "../../style/notfound.module.css";
import skeletonStyles from "../../style/skeleton.module.css";

const NotFoundPageSkeleton = () => (
  <div
    className={`${styles.notfoundWrapper} skeleton-page`}
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading page"
  >
    <div className="container container-sm-fluid page-shell">
      <div className={`row justify-content-center ${styles.notfoundContentWrapper}`}>
        <div className="col-12 col-md-10 col-lg-8 text-center">
          <Skeleton className={`${skeletonStyles.skeletonTitle} mx-auto`} />
          <div className={`${skeletonStyles.skeletonStack} mt-4`}>
            <Skeleton className={skeletonStyles.skeletonParagraph} />
            <Skeleton
              className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort} mx-auto`}
            />
          </div>
          <Skeleton
            className={`${skeletonStyles.skeletonButton} mx-auto mt-4`}
          />
        </div>
      </div>
    </div>
  </div>
);

export default NotFoundPageSkeleton;
